import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DispatchParameters } from "src/app/models/DispatchParameters";
import { ScheduleDefaults } from "src/app/models/ScheduleDefaults";
import { ScheduleParameters } from "src/app/models/ScheduleParameters";
import { ScheduleDataService } from "../../services/schedule-data.service";
import { StorageService } from "../services/storage.service";
import { LoadingService } from "../services/loading.service";
import { SearchParamsModel } from "../models/search-params-model";
import { ScheduleItem } from "src/app/models/ScheduleItem";
import { Schedule } from "src/app/models/Schedule";
import { LoadData } from "../models/LoadData";
import { LoadBankApplyParameters } from "src/app/models/LoadBankApplyParameters";
import { FormStatus, LoadBankType } from "src/app/models/Enums";
import { DeleteParameters } from "src/app/models/DeleteParameters";
import { DeleteComponent } from "src/app/delete-confirm/delete-confirm.component";
import { LoadBankApplyLoads } from "src/app/models/LoadBankApplyLoads";
import { AlertParameters } from "src/app/models/AlertParameters";
import { DispatchItem } from "../../models/DispatchItem";

@Component({
    selector: "app-filter-schedules",
    templateUrl: "view-dispatch.component.html",
    styleUrls: ["view-dispatch.component.css"],
    standalone: false
})
export class ViewDispatchComponent implements OnInit {
  scheduleId: string;
  loadsData: LoadData[] = [];
  searchdata: ScheduleParameters;
  scheduleForm = new ScheduleDefaults();
  scheduleParms = new ScheduleParameters();
  errorMessage = "";
  schedule: Schedule;
  dispatchList: DispatchItem[] = [];
  dispatchForm = new DispatchParameters();
  enableDisableMessageButton = true;
  dispatchesCount = 0;
  isApiLoaded = false;
  sendAlertTruckerDispatchId: number = null;
  alertTruckerForm: AlertParameters = new AlertParameters();
  searchDataFromStorage: SearchParamsModel;
  storedDataFromLS: SearchParamsModel;
  origins: ScheduleItem[] = [];
  destinations: ScheduleItem[] = [];
  dispatchFormId: string = 'dispatchModal';
  scheduleLocationType: string = '';
  @ViewChild('deleteConfirmChildComponent') deleteConfirmChildComponent!: DeleteComponent;
  showMoreIcons: boolean = false;
  isInitialLoad: boolean = true;
  isShowSchedule = false;
  hasOpenedIcon: boolean = false;
  message: string = "";
  alertTruckerFilterModalIdSc: string = "alertTruckerFilterModalId";
  @ViewChild('loadsModalBtn') loadButton!: ElementRef<HTMLButtonElement>;
  loadBankApplyFormId: string = "loadBankApplyModalVd";
  globalDispatchId = null;
  loadBankApplyParametersVd: LoadBankApplyParameters = new LoadBankApplyParameters();
  formStatus: FormStatus;
  deleteItemParams: DeleteParameters;
  deleteFormId: string = "deleteModal";
  loadBankType: LoadBankType;
  confirmDispatchFormId: string = "confirmDispatchModal-LoadsStatusModal";
  sendDispatchId: number = null;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private scheduleDataService: ScheduleDataService,
    private loadingService: LoadingService,
    private _storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.initializeData();
    this.storageService.clearData("selectedTruckersInfo");
    this.storedDataFromLS = this._storageService.getData<SearchParamsModel>('advancedSearchFormParams') ?? new SearchParamsModel();
  }

  private initializeData(): void {
    this.searchdata = this.scheduleDataService.scheduleParms;
    this.scheduleId = this.route.snapshot.params["id"];
    if (Number(this.scheduleId) > 0) {
      this.fetchDispatchData();
    }
  }

  private fetchDispatchData(): void {
    this.getDispatches();
    this.getSchedule();
    this.newDispatch();
  }

  getDay(pickupDate: string): string {
    const date = new Date(pickupDate);
    return date.toLocaleString('en-US', { weekday: 'short' });
  }


  getDispatches(): void {
    this.searchDataFromStorage = this.storageService.getData<SearchParamsModel>('advancedSearchFormParams') ?? new SearchParamsModel();
    this.scheduleLocationType = this.searchDataFromStorage.locationType == 1 ? "Destination" : "Origin";
    this.scheduleParms = this.scheduleDataService.getCurrentPageData()?.searchdata ?? this.mapStoredDataToScheduleParams();

    this.loadingService.runWithLoader(
      this.scheduleDataService.getScheduleDispatches(Number(this.scheduleId))).subscribe({
        next: (data) => {
          this.isApiLoaded = true;
          this.hasOpenedIcon = false;
          this.dispatchList = data;
          this.dispatchesCount = this.dispatchList.length;
        },
        error: (err) => {
          this.errorMessage = err;
          this.isApiLoaded = true;
        },
      });
  }

  private mapStoredDataToScheduleParams(): ScheduleParameters {
    const { locCode, selectedPeriodRange, locationType, periodStartDate, periodEndDate } = this.searchDataFromStorage;
    return {
      ...this.scheduleParms,
      locCode,
      selectedPeriodRange,
      locationType: Number(locationType),
      periodStartDate,
      periodEndDate,
    };
  }

  getSchedule(): void {
    this.loadingService.runWithLoader(this.scheduleDataService.getSchedule(Number(this.scheduleId))).subscribe({
      next: (data) => this.schedule = data,
      error: (err) => this.errorMessage = err,
    });
  }

  manualScheduleClick(): void {
    this.scheduleForm = this.getScheduleDefaults();
    this.newDispatch();
  }

  private getScheduleDefaults(): ScheduleDefaults {
    const { locationType, locCode, periodStartDate, periodEndDate } = this.scheduleParms;
    return { scheduleId: 0, locationType, locCode, periodStartDate, periodEndDate };
  }

  newDispatch(): void {
    this.dispatchForm = { scheduleId: Number(this.scheduleId), locCode: this.searchDataFromStorage.locCode } as DispatchParameters;
  }

  dispatchSaveComplete(dispatchId: number): void {
    this.message = !this.dispatchForm.dispatchId ? "1 new dispatch has been created." : "Dispatch has been updated.";
    setTimeout(() => {
      this.message = "";
    }, 3000);
    this.ngOnInit();
  }

  redirectToHome(): void {
    this.scheduleDataService.scheduleParms = this.searchdata;
    this.router.navigate(["/mobile"]);
  }

  redirectToDispatch(dispatchId: number, loadbreakout: boolean): void {
    this.router.navigate([loadbreakout ? "/dispatch-detail-day" : "/dispatch-detail-noday", dispatchId]);
  }

  redirectToTruckerAlert(): void {
    this.router.navigate(["/alert-truckers-filter", this.scheduleId]);
  }

  advancedSearch(): void {
    this.router.navigate(["/schedule-mobile"], { state: { isBackClicked: true } });
  }

  editDispatch(scheduleId: number, dispatchId: number) {
    let parms = new DispatchParameters();
    parms.locCode = this.storedDataFromLS.locCode;
    parms.scheduleId = scheduleId;
    parms.dispatchId = dispatchId;
    this.dispatchForm = parms;
  }

  setSelectedLoadItem(dispatchId: number) {
    this.scheduleDataService.getDispatchLoadItems(dispatchId).subscribe({
      next: (data) => {
        this.loadsData = data;
      },
      error: (err) => (this.errorMessage = err),
    });
  }

  toggleIcons(item: any) {
    this.isInitialLoad = false;
    this.hasOpenedIcon = !item.showMoreIcons;
    this.dispatchList.forEach((data: any) => {
      if (data !== item) data.showMoreIcons = false;
    });
    item.showMoreIcons = !item.showMoreIcons;
  }

  isShowMoreIconsEnabledInAnyDispatch(): boolean {
    return this.dispatchList.filter(x => x.showMoreIcons === true)?.length == 0 || this.isInitialLoad;
  }

  reloadDispatchCount(dispatchId: number) {
    const dispatch = this.dispatchList.find(d => d.dispatchId === dispatchId);

    if (dispatch) {
      dispatch.numberOfLoads = Math.max(0, dispatch.numberOfLoads - 1);
    }
  }

  loadLoads(event: any) {
    this.globalDispatchId = event;
    this.loadButton.nativeElement.click();
  }

  openLoadBank(loadBankType: LoadBankType, dispatch) {
    let parameters = new LoadBankApplyParameters();
    parameters.parentModal = this.loadBankApplyFormId;
    parameters.locCode = this.searchDataFromStorage.locCode;
    parameters.loadBankType = loadBankType;
    parameters.commodityCode = dispatch.commodityCode;
    parameters.dispatchId = dispatch.dispatchId;
    parameters.contractIds = [];
    this.loadBankApplyParametersVd = parameters;
    this.loadBankType = loadBankType;
    return false;
  }

  deleteItem(status: boolean, deleteParameters: DeleteParameters) {
    if (status) {
      this.formStatus = FormStatus.Deleting;
      this.scheduleDataService.deleteDispatch(deleteParameters.dispatchId).subscribe({
        next: data => {
          this.deleteConfirmChildComponent.close();
          this.dispatchList = this.dispatchList.filter(x => x.dispatchId != deleteParameters.dispatchId);
          this.dispatchesCount = this.dispatchList.length;
          this.formStatus = FormStatus.Normal;
          this.hasOpenedIcon = false;
        },
        error: err => this.errorMessage = err
      });
    }
  }

  deleteDispatch(dispatchId: number, truckerName: string) {
    let parms = new DeleteParameters()
    parms.dispatchId = dispatchId;
    parms.title = `Are you sure you want to delete the dispatch ${truckerName}?`
    this.deleteItemParams = parms;
    return false;
  }

  loadBankApplyComplete(event: { dispatchId: number, loadBankApplyLoads: LoadBankApplyLoads }) {
    const dispatchId = event.dispatchId;
    const loadBankIds = event.loadBankApplyLoads.loadBankIds;
    this.scheduleDataService.updateLoadBankApply(dispatchId, loadBankIds, this.loadBankType == LoadBankType.Unload).subscribe({
      next: data => {

      },
      error: err => this.errorMessage = err
    });
  }
  sendComplete(event: number[]) {
    if (event.length > 0) {
      setTimeout(() => {
        this.getDispatches();
      }, 3000);
    }

  }
  sendDispatch(dispatchId: number) {
    this.sendDispatchId = dispatchId;
  }

  sendAlertTruckerDispatch(dispatch: any) {
    this.sendAlertTruckerDispatchId = dispatch.dispatchId;
    let parms = new AlertParameters();
    parms.scheduleId = dispatch.scheduleId;
    parms.dispatchId = dispatch.dispatchId;
    parms.truckerId = dispatch.truckerId;
    parms.periodStartDate = this.storedDataFromLS.periodStartDate;
    parms.periodEndDate = this.storedDataFromLS.periodEndDate;
    parms.selectedLocCodeInFilter = this.storedDataFromLS.locCode;
    parms.isRequestFromSendTextAlertForm = false;
    parms.locationType = this.storedDataFromLS.locationType;
    parms.locCode = this.storedDataFromLS.locCode;
    this.alertTruckerForm = parms;
  }
}
